import { RedirectConfig } from './redirectMappingsTypes'

export const specialistRedirects: RedirectConfig[] = [
  {
    source: /\/specialist\/(\d+).*/,
    destination: `/specialists/{{0}}`,
    permanent: true,
  },
]
